var App = App || {};

App.TreeListNavigation = (function ($) {
    return {
        init: init
    };

    function init() {
        initTreeListArrowKeys();
        expandCurrentNodeIfClickedOutside();
    }

    function isRevealModalOpen() {
        return $('.reveal-modal.open').length > 0;
    }

    function initTreeListArrowKeys() {
        $(document).on('keydown', function (e) {
            var $treeList = $('.js-nav-tree');
            if ($treeList.length && !isRevealModalOpen()) {
                handleArrowKeys(e);
            }
        });
    }

    function handleTreeListToggle($currentNavTreeLink) {
        var treeType = $currentNavTreeLink.closest('.js-nav-tree').attr('data-tree-type');

        if (treeType === 'book-toc') {
            var isNavTreeLink = $currentNavTreeLink.find('.js-show-headings-icon').length || $currentNavTreeLink.siblings('.js-show-headings-button').find('.js-show-headings-icon').length;
            var isBookPartHeading = $currentNavTreeLink.closest('.js-nav-tree-item').find('.js-show-headings-icon').first().length;
            if (isNavTreeLink) {
                SCM.BookToc.Headings.onHeadingsClick({ target: $currentNavTreeLink[0] });
            } else if (isBookPartHeading) {
                var bookPartHeadingIcon = $($currentNavTreeLink[0]).find('.js-show-book-parts-icon');
                SCM.BookToc.Headings.onBookPartHeadingsClick({ target: bookPartHeadingIcon });
            }
        } else if (treeType === 'navigation-menu') {
            App.NavigationMenu.onParentNodeClick($currentNavTreeLink);
        } else if (treeType === 'issue-toc') {
            SCM.Issues.onIssueHeadingClick($currentNavTreeLink);
        }
    }

    function handleArrowKeys(e) {
        var $focusedElement = $(document.activeElement);
        var isSplitView = $('.js-sv-main:visible').length;

        // If focus not in nav tree, return
        var navTreeParentClassName = isSplitView ? 'resources-panel' : 'js-left-nav-col';
        if (!$focusedElement.hasClass(navTreeParentClassName) && !$focusedElement.closest('.' + navTreeParentClassName).length) {
            return;
        }

        // Use arrow keys starting from the focused element if it is visible in the nav tree.
        // Otherwise, if it is a toggle in the nav tree, use the sibling link element.
        // Otherwise, use the current node element if it is visible.
        // Otherwise, default to the first .js-nav-tree-link element.
        var $currentNavTreeLink;
        var isNavTreeLink = $focusedElement.hasClass('js-nav-tree-link');
        var $jsNavTreeLink = isNavTreeLink ? $focusedElement : null;

        if ($jsNavTreeLink === null && $focusedElement.hasClass('js-nav-tree-toggle')) {
            $jsNavTreeLink = $focusedElement.siblings('.js-nav-tree-link').first();
        }

        if (isSplitView) {
            $currentNavTreeLink = $jsNavTreeLink || $('.js-sv-main .js-nav-tree [aria-current="true"]').first();

            if (!$currentNavTreeLink.length) {
                $currentNavTreeLink = $('.js-sv-main .js-nav-tree .js-nav-tree-link').first();
            }
        } else {
            $currentNavTreeLink = $jsNavTreeLink || $('.js-nav-tree [aria-current="true"]').first();

            if (!$currentNavTreeLink.length) {
                $currentNavTreeLink = $('.js-nav-tree .js-nav-tree-link').first();
            }
        }

        var $allVisibleNavTreeLinks = $('.js-nav-tree').find('.js-nav-tree-link:visible');
        var currentIndex = $allVisibleNavTreeLinks.index($currentNavTreeLink);

        if (e.key === 'ArrowUp') {
            e.preventDefault();
            focusPreviousVisibleItem($allVisibleNavTreeLinks, currentIndex, $currentNavTreeLink);
        }

        if (e.key === 'ArrowDown') {
            e.preventDefault();

            // If we are not on a nav tree link then don't increment the index.
            // This is to ensure that when we first arrow down into the ToC we initially
            // land on the first item in the list.
            if (isNavTreeLink) {
                currentIndex++;
            }
            focusNextVisibleItem($allVisibleNavTreeLinks, currentIndex, $currentNavTreeLink);
        }

        if (e.key === 'ArrowRight') {
            e.preventDefault();
            expandParentNode($currentNavTreeLink);
        }

        if (e.key === 'ArrowLeft') {
            e.preventDefault();
            collapseParentNode($currentNavTreeLink);
        }
    };

    function focusPreviousVisibleItem($allVisibleNavTreeLinks, currentIndex, $currentNavTreeLink) {
        if (currentIndex > 0) {
            $allVisibleNavTreeLinks.eq(currentIndex - 1).focus();
        } else if (currentIndex === 0) {
            $currentNavTreeLink.focus();
        }
    }

    function focusNextVisibleItem($allVisibleNavTreeLinks, currentIndex, $currentNavTreeLink) {
        if (currentIndex !== -1 && currentIndex <= $allVisibleNavTreeLinks.length - 1) {
            $allVisibleNavTreeLinks.eq(currentIndex).focus();
        }
    }

    function expandParentNode($currentNavTreeLink) {
        // This will either select itself or allow the 'View Chapter' links on Book TOC to expand the parent
        $currentNavTreeLink = $currentNavTreeLink.closest('.js-nav-tree-item').find('.js-nav-tree-link[role="treeitem"]').first();

        if ($currentNavTreeLink.attr('aria-expanded') === 'false' &&
            ($currentNavTreeLink.siblings('.js-nav-tree-toggle').first().length || $currentNavTreeLink.hasClass('js-nav-tree-toggle'))) {
            handleTreeListToggle($currentNavTreeLink);
            $currentNavTreeLink.focus();
        } else if ($currentNavTreeLink.hasClass('js-nav-tree-link')) {
            $currentNavTreeLink.focus();
        }
    }

    function collapseParentNode($currentNavTreeLink) {
        var $currentNavTreeItem = $currentNavTreeLink.closest('.js-nav-tree-item');
        // This will either select itself or allow the 'View Chapter' links on Book TOC to collapse the parent
        $currentNavTreeLink = $currentNavTreeItem.find('.js-nav-tree-link[role="treeitem"]').first();

        var $parentNavTreeItem = $currentNavTreeItem.closest('.js-nav-tree-sublist').closest('.js-nav-tree-item');
        var $parentNavTreeLink = $parentNavTreeItem.find('.js-nav-tree-link').first();

        if ($currentNavTreeLink.attr('aria-expanded') === 'true') {
            handleTreeListToggle($currentNavTreeLink);
            $currentNavTreeLink.focus();
        } else if ($parentNavTreeLink.length && $parentNavTreeLink.attr('aria-expanded') === 'true') {
            handleTreeListToggle($parentNavTreeLink);
            $parentNavTreeLink.focus();
        } else if ($currentNavTreeLink.hasClass('js-nav-tree-link')) {
            $currentNavTreeLink.focus();
        }
    }

    // Expand ancestors of current node if there is a click outside of the tree or tab anywhere
    function expandCurrentNodeIfClickedOutside() {
        $(document).on('click keydown', function (e) {
            if ((e.type === 'click' && $(e.target).closest('.js-nav-tree').length === 0) || e.key === 'Tab') {
                var $currentNavTreeLink = $('.js-sv-main:visible').length ? $('[aria-current="true"]').last() : $('[aria-current="true"]').first();
                var $currentNavTreeItem = $currentNavTreeLink.closest('.js-nav-tree-item');
                expandAllAncestors($currentNavTreeItem);
            }
        });
    };

    function expandAllAncestors($currentNavTreeItem) {
        $currentNavTreeItem.parents('.js-nav-tree-item').each(function () {
            var $parentNodeLink = $(this).find('.js-nav-tree-link');
            if ($parentNodeLink.attr('aria-expanded') === 'false') {
                handleTreeListToggle($parentNodeLink);
            }
        });
    }
})(jQuery);